module.exports = __webpack_public_path__ + "static/media/Verge.11183204.png";